import { color, spacing } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon, Props } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'react-native-elements/dist/image/Image';
import { Button } from '../Button/Button';

interface ImageDisplayProps {
  uri: string;
  icon?: Props;
  onClear?: () => void;
}

const ImageDisplay: FC<ImageDisplayProps> = ({ uri, icon, onClear }) => {
  return (
    <View>
      <Image style={styles.image} source={{ uri }}>
        <Button preset="secondary" onPress={onClear}>
          <FontAwesomeIcon
            icon="times"
            size={21}
            color={color.primary}
            {...icon}
          />
        </Button>
      </Image>
    </View>
  );
};

// Styles
const styles = StyleSheet.create({
  image: {
    height: 270,
    width: 560,
    padding: spacing[3],
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

export default ImageDisplay;
